var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewFooterLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "new-footer-logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.587,
    height: 65.476,
    viewBox: "0 0 71.587 65.476",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M163.476,300.166s-10.69.095-13.66-2.546a24.5,24.5,0,0,1,2.7-26.621L132,277.081l8.162,23.785.008.009.007.007.02.02.016.016.03.029.025.023.041.037.037.031.052.043.048.038.064.049.061.045.076.055.073.05.09.06.086.056.1.064.1.06.119.068.114.064.135.072.128.066.154.076.142.069.174.079.154.069.206.086.157.065c.087.035.181.07.274.105l.218.081c.109.039.219.079.335.118l.2.065c.09.029.179.059.274.088l.233.069c.093.027.184.055.281.082l.256.069.3.079.279.068c.1.026.21.051.319.076l.3.067.339.072.325.064.362.068.348.061.387.063.369.057.414.059.39.052.442.053.413.047c.154.016.313.032.471.047.143.014.286.028.433.041.165.014.336.027.506.04.15.012.3.024.451.034.18.012.367.023.553.034.152.009.3.019.457.026.2.01.413.018.622.026.148.006.293.013.444.018.271.009.551.015.832.021l.289.007h0q1.181.019,2.485,0c13.991-.233,19.121,4.664,13.525,10.027s-16.09,7.25-16.09,7.25h32.413S218.041,301.565,163.476,300.166Z",
    transform: "translate(-131.996 -255.931)",
    fill: "#2a7de1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M239.527,424.288q-1.305.022-2.485,0a24.435,24.435,0,0,0,16.915,6.776c.407,0,.812-.011,1.214-.031C256.09,427.119,250.573,424.1,239.527,424.288Z",
    transform: "translate(-214.343 -376.076)",
    fill: "#ffc629"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M350.67,208.156a24.52,24.52,0,0,1,12.974,36.59l11.36-.2V200.943Z",
    transform: "translate(-303.417 -200.943)",
    fill: "#2a7de1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M204.543,264.44c2.961,2.646,13.666,2.551,13.666,2.551,12.624.324,20.665,1.635,25.571,3.459a24.527,24.527,0,1,0-39.237-6.01Z",
    transform: "translate(-186.729 -222.686)",
    fill: "#ffc629"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M204.543,264.44c2.961,2.646,13.666,2.551,13.666,2.551,12.624.324,20.665,1.635,25.571,3.459a24.527,24.527,0,1,0-39.237-6.01Z",
    transform: "translate(-186.729 -222.686)",
    fill: "#ffc629"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFooterLogo);
export default __webpack_public_path__ + "static/media/new-footer-logo.52d2c75687dbc72a917d45896d248287.svg";
export { ForwardRef as ReactComponent };